// extracted by mini-css-extract-plugin
export var statItem = "_jv-1";
export var statsRow = "_jv-0";